import { Actions } from './commonActions';

import { Actions as ReclamationsActions } from '../reclamation/reclamationsActions';


/**
 * Etat initial des notifications
 */
const initialState = {
    //notification: {
    //    open: false,
    //    message: '',
    //    importance: 'information',
    //    closable: false,
    //    url: null
    //},
    notifications: [], 
    affectationDialogOpen: false,
    affectation: {
        isAdding: false
    },

    addReclamationDialogOpen: false,
    addReclamation: {
        reclamationLiee: false,
        reclamationParentId: -1,
        infosLogistique: null
    },
    addReclamationButtonDisabled: false,
    addReclamationButtonHidden: false,

    importSouffranceDialogOpen: false,

    observateursDialogOpen: false,

    addMemoDialogOpen: false,
    memo: {
        isAdding: false,
        reclamationId: 0
    },

    addQuestionDialogOpen: false,
    question: {
        reclamationId: 0,
        isAdding: false
    },

    clotureDialogOpen: false,
    cloture: {
        reclamationId: 0
    },

    annulerClotureDialogOpen: false,
    annulerCloture: {
        reclamationId: 0
    },

    addActionDialogOpen: false,
    addActionData: {
        isAdding: false,
        actionId: 0, 
        reclamationId: 0,
        action: null
    },
    setDateVerificationDialogOpen: false,
    setDateVerificationData: {
        isAdding: false,
        reclamationId: 0,
        date: null
    },
    dropZone: {
        fichiers: []
    }
};

/**
 * Reducer pour les notifications
 * Retourne le nouvel état en fonction de l'action
 * @param {object} state l'état courant
 * @param {object} action une action
 * @returns {object} le nouvel état
 */
const reducer = (state = initialState, action) => {

    switch (action.type) {

        // Gestion des notifications
        case Actions.ADD_NOTIFICATION: {

            let notification = {
                open: true,
                key: Math.trunc(Math.random() * 1000000000000),
                message: action.message,
                importance: action.importance,
                closable: action.closable,
                url: action.url
            };

            let newState = { ...state, notifications: [...state.notifications, notification]};

            return newState;
        }
        case Actions.REMOVE_NOTIFICATION: {

            let newState = { ...state, notifications: [...state.notifications] };

             newState.notifications.shift();

            return newState;
        }
        case Actions.REMOVE_ALL_NOTIFICATIONS: {

            let newState = { ...state, notifications: [] };
            
            return newState;
        }

        // Gestion de l'affectation d'une réclamation
        case Actions.OPEN_AFFECTATION_DIALOG:
            return {
                ...state,
                affectationDialogOpen: true,
                addReclamationButtonDisabled: true
            };
        case Actions.CLOSE_AFFECTATION_DIALOG:
            return {
                ...state,
                affectationDialogOpen: false,
                addReclamationButtonDisabled: false
            };

        
        case ReclamationsActions.AFFECTATION_REQUEST:
            return {
                ...state,
                affectation: { ...state.affectation, isAdding: true }
            };

        case ReclamationsActions.AFFECTATION_SUCCESS:
            return {
                ...state,
                affectationDialogOpen: false,
                affectation: { ...state.affectation, isAdding: false },
                addReclamationButtonDisabled: false
            };

        case ReclamationsActions.AFFECTATION_FAILURE:
            return {
                ...state,
                affectation: { ...state.affectation, isAdding: false },
                addReclamationButtonDisabled: false
            };

        case ReclamationsActions.AFFECTATION_WARNING:
            return {
                ...state,
                affectation: { ...state.affectation, isAdding: false }
            };






        // Gestion de l'ajout d'une réclamation
        case Actions.OPEN_ADD_RECLAMATION_DIALOG:
            return {
                ...state,
                addReclamationDialogOpen: true,
                addReclamationButtonDisabled: true,
                addReclamation: {
                    ...state.addReclamation,
                    reclamationLiee: action.reclamationLiee,
                    reclamationParentId: action.reclamationParentId,
                    infosLogistique: action.infosLogistique
                },
                dropZone: {
                    fichiers: []
                }
            };
        case Actions.CLOSE_ADD_RECLAMATION_DIALOG:
            return {
                ...state,
                addReclamationDialogOpen: false,
                addReclamationButtonDisabled: false,
                addReclamation: {
                    ...state.addReclamation,
                    reclamationLiee: false,
                    reclamationParentId: -1,
                    infosLogistique: null
                },
                dropZone: {
                    fichiers: []
                }
            };

        // Gestion des observateurs d'une réclamation
        case Actions.OPEN_OBSERVATEURS_DIALOG:
            return {
                ...state,
                observateursDialogOpen: true,
                addReclamationButtonDisabled: true
            };
        case Actions.CLOSE_OBSERVATEURS_DIALOG:
            return {
                ...state,
                observateursDialogOpen: false,
                addReclamationButtonDisabled: false
            };

        // Gestion de l'ajout d'un mémo
        case Actions.OPEN_ADD_MEMO_DIALOG:
            return {
                ...state,
                addMemoDialogOpen: true,
                addReclamationButtonDisabled: true,
                memo: { reclamationId: action.reclamationId, isAdding: state.memo.isAdding },
                dropZone: {
                    fichiers: []
                }
            };
        case Actions.CLOSE_ADD_MEMO_DIALOG:
            return {
                ...state,
                addMemoDialogOpen: false,
                addReclamationButtonDisabled: false,
                dropZone: {
                    fichiers: []
                }
            };

        case ReclamationsActions.ADD_MEMO_REQUEST:
            return {
                ...state,
                memo: { ...state.memo, isAdding: true }
            };

        case ReclamationsActions.ADD_MEMO_SUCCESS:
            return {
                ...state,
                addMemoDialogOpen: false,
                memo: { ...state.memo, isAdding: false },
                addReclamationButtonDisabled: false
            };

        case ReclamationsActions.ADD_MEMO_FAILURE:
            return {
                ...state,
                memo: { ...state.memo, isAdding: false },
                addReclamationButtonDisabled: false
            };


        // Gestion de l'ajout d'une question
        case Actions.OPEN_ADD_QUESTION_DIALOG:
            return {
                ...state,
                addQuestionDialogOpen: true,
                addReclamationButtonDisabled: true,
                question: { ...state.question, reclamationId: action.reclamationId },
                dropZone: {
                    fichiers: []
                }
            };
        case Actions.CLOSE_ADD_QUESTION_DIALOG:
            return {
                ...state,
                addQuestionDialogOpen: false,
                addReclamationButtonDisabled: false,
                dropZone: {
                    fichiers: []
                }
            };


        case ReclamationsActions.ADD_QUESTION_REQUEST:
            return {
                ...state,
                question: { ...state.question, isAdding: true }
            };

        case ReclamationsActions.ADD_QUESTION_SUCCESS:
            return {
                ...state,
                addQuestionDialogOpen: false,
                question: { ...state.question, isAdding: false },
                addReclamationButtonDisabled: false
            };

        case ReclamationsActions.ADD_QUESTION_FAILURE:
            return {
                ...state,
                question: { ...state.question, isAdding: false },
                addReclamationButtonDisabled: false
            };
        

        // Gestion de la cloture d'une réclamation
        case Actions.OPEN_CLOTURE_DIALOG:
            return {
                ...state,
                clotureDialogOpen: true,
                addReclamationButtonDisabled: true,
                cloture: { reclamationId: action.reclamationId },
                dropZone: {
                    fichiers: []
                }
            };
        case Actions.CLOSE_CLOTURE_DIALOG:
            return {
                ...state,
                clotureDialogOpen: false,
                addReclamationButtonDisabled: false,
                dropZone: {
                    fichiers: []
                }
            };

        // Gestion de l'annulation de la cloture d'une réclamation
        case Actions.OPEN_ANNULER_CLOTURE_DIALOG:
            return {
                ...state,
                annulerClotureDialogOpen: true,
                addReclamationButtonDisabled: true,
                annulerCloture: { reclamationId: action.reclamationId },
                dropZone: {
                    fichiers: []
                }
            };
        case Actions.CLOSE_ANNULER_CLOTURE_DIALOG:
            return {
                ...state,
                annulerClotureDialogOpen: false,
                addReclamationButtonDisabled: false,
                dropZone: {
                    fichiers: []
                }
            };

        // Gestion de l'ajout d'une action
        case Actions.OPEN_ADD_ACTION_DIALOG:
            return {
                ...state,
                addActionDialogOpen: true,
                addReclamationButtonDisabled: true,
                addActionData: { ...state.addActionData, reclamationId: action.reclamationId, action: action.action },
                dropZone: {
                    fichiers: []
                }
            };
        case Actions.CLOSE_ADD_ACTION_DIALOG:
            return {
                ...state,
                addActionDialogOpen: false,
                addReclamationButtonDisabled: false,
                dropZone: {
                    fichiers: []
                }
            };


        case ReclamationsActions.ADD_ACTION_REQUEST:
            return {
                ...state,
                addActionData: { ...state.addActionData, actionId: action.actionId, isAdding: true }
            };

        case ReclamationsActions.ADD_ACTION_SUCCESS:
            return {
                ...state,
                addActionDialogOpen: false,
                addActionData: { ...state.addActionData, actionId: 0, isAdding: false },
                addReclamationButtonDisabled: false
            };

        case ReclamationsActions.ADD_ACTION_FAILURE:
            return {
                ...state,
                addActionData: { ...state.addActionData, actionId: 0, isAdding: false },
                addReclamationButtonDisabled: false
            };



        // Gestion de la modification de la date de vérification d'une réclamation
        case Actions.OPEN_SET_DATE_VERIFICATION_DIALOG:
            return {
                ...state,
                setDateVerificationDialogOpen: true,
                addReclamationButtonDisabled: true,
                setDateVerificationData: { reclamationId: action.reclamationId, date: action.date }
            };
        case Actions.CLOSE_SET_DATE_VERIFICATION_DIALOG:
            return {
                ...state,
                setDateVerificationDialogOpen: false,
                addReclamationButtonDisabled: false
            };

        // Gestion de la mise à jour de la dropZone
        case Actions.UPDATE_DROPZONE:
            {
                return {
                    ...state,
                    dropZone: action.dropZone
                };
            }


        // Gestion de la mise à jour de la date de vérification
        case ReclamationsActions.SET_DATE_VERIFICATION_REQUEST:
            {
                return {
                    ...state,
                    setDateVerificationData: { ...state.setDateVerificationData, isAdding: true }
                };
            }

        case ReclamationsActions.SET_DATE_VERIFICATION_SUCCESS:
            {
                return {
                    ...state,
                    setDateVerificationDialogOpen: false,
                    setDateVerificationData: { ...state.setDateVerificationData, isAdding: false }
                };
            }

        case ReclamationsActions.SET_DATE_VERIFICATION_FAILURE:
            {
                return {
                    ...state,
                    setDateVerificationData: { ...state.setDateVerificationData, isAdding: false }
                };
            }



        case Actions.ENTER_ADMINISTRATION_MODE:
            {
                return {
                    ...state,
                    addReclamationButtonHidden: true
                };
            }


        case Actions.LEAVE_ADMINISTRATION_MODE:
            {
                return {
                    ...state,
                    addReclamationButtonHidden: false
                };
            }



        case Actions.OPEN_IMPORT_SOUFFRANCE_DIALOG:
            {
                return {
                    ...state,
                    importSouffranceDialogOpen: true
                };
            }

        case Actions.CLOSE_IMPORT_SOUFFRANCE_DIALOG:
            {
                return {
                    ...state,
                    importSouffranceDialogOpen: false
                };
            }


        default:
            return state;
    }
};

export default reducer;
